/**
 * Find modulo of an integer number of ANY length
 */
export const modulo = (dividend: string, divisor: number): number => {
    return dividend
        .split('')
        .map(char => Number(char))
        .reduce((remainder, nmb) => (remainder * 10 + nmb) % divisor, 0);
};
